import "./Banglore_cities.css";
const Kolkata_cities = ()=>{
    return(
        <div className="main_div">
            <h2 className="city">Popular Localities</h2>
            <p className="city">New Town</p>
            <p className="city">Howrah Railway Station</p>
            <p className="city">Salt Lake City</p>
            <p className="city">Park Street</p>
            <p className="city">Kolkata International Airport</p>
            <p className="city">Sealdah Railway Station</p>
            <p className="city">Dum Dum</p>
            <p className="city">Park Circus</p>
            <p className="city">All of Kolkata</p>
           
        </div>
    )
}
export {Kolkata_cities}